<template>
  <VCard
    flat
    class="d-flex flex-column justify-center align-center grey lighten-4 fill-height pt-6 pt-lg-9 pb-6 pb-lg-9 px-2" width="100%"
  >
    <img src="../../assets/img/interview/broken-video.svg">
    <span class="subitle-1 text-center mt-6 font-weight-medium">
      {{ $t('videoProcessingFailed') }}
    </span>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateInterviewProcessingFailed',
};
</script>

<i18n locale="en" lang="yaml">
  videoProcessingFailed: Sorry, we were unable to process the video
</i18n>

<i18n locale="ru" lang="yaml">
  videoProcessingFailed: К сожалению, мы не смогли обработать записанное видео
</i18n>
